export const DEFAULT_ACTION = "app/ReinvestigateCasesDetails/DEFAULT_ACTION";
export const CASEREINVESTIGATEDETAILS = "app/ReinvestigateCasesDetails/CASEREINVESTIGATEDETAILS";
